import { gql } from '@apollo/client';

import pipelineIntegration from '../pipelineIntegration';
import buildConsentVars from '../buildConsentVars';

export const mutation = gql`
  mutation InsertPipelineIntegration($pipeline_integrations_insert_input: pipeline_integrations_insert_input!) {
    insert_pipeline_integrations_one(object: $pipeline_integrations_insert_input) {
      ...pipelineIntegration
    }
  }
  ${pipelineIntegration}
`;

export function buildVariables({
  pipelineId,
  integrationId,
  consentCategoryId,
  consentMode,
  playbookId,
  pipelineVars,
  readyForDeploy,
  disabled,
}) {
  return {
    pipeline_integrations_insert_input: {
      pipelineId,
      integrationId,
      ...buildConsentVars({ consentCategoryId, consentMode }),
      staged_revision: {
        data: {
          pipelineVars,
          readyForDeploy,
          playbookId,
        },
      },
      disabled,
    },
  };
}
